import React from 'react';
import { Select } from 'antd';
import { SERVICEINVOICE } from 'constants/types';
import { configManager, useAuthContext } from 'react-structure-admin';

const EnvironmentTypeSelect = ({ invoiceModel, ...props }) => {
  const { isAdmin } = useAuthContext();
  const isTestMode = configManager.getConfig().isTestMode;

  return (
    <Select {...props}>
      {(!isTestMode || isAdmin()) && (
        <Select.Option value="production">Produção</Select.Option>
      )}
      <Select.Option value="development">Homologação</Select.Option>
      {isTestMode && invoiceModel === SERVICEINVOICE && (
        <Select.Option value="simulation">Simulação</Select.Option>
      )}
    </Select>
  );
};

export default EnvironmentTypeSelect;
